import { memo } from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

/**
 * NoPendingNotifications component displays a message when there are no pending notifications.
 * It uses the `useTranslation` hook to fetch the localized message for no notifications.
 *
 * @returns {JSX.Element} A styled div containing the no notifications message.
 */
function NoPendingNotifications(): JSX.Element {
  const { t } = useTranslation('global');
  return (
    <div
      style={{
        height: 200,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Typography variant="body1">
        {t('notifications.noNotifications')}
      </Typography>
    </div>
  );
}

export default memo(NoPendingNotifications);
